const SHOESITEM = [
  {
    id:'1',
    name:'에르메스 신발1',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:10,
    delivery:0
  },
  {
    id:'2',
    name:'에르메스 신발2',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:20,
    delivery:0
  },
  {
    id:'3',
    name:'에르메스 신발3',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:30,
    delivery:0
  },
  {
    id:'4',
    name:'에르메스 신발4',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:40,
    delivery:0
  },
  {
    id:'5',
    name:'에르메스 신발5',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:50,
    delivery:0
  },
  {
    id:'6',
    name:'에르메스 신발6',
    price:1200000,
    img: require('../assets/images/shoes_item.png'),
    sellCount:60,
    delivery:0
  },
]

export default SHOESITEM;